import axios from "axios";
import { BACKEND_URL } from "../config/config";
import {
  ACCOUNTS,
  DISPLAYNAME,
  EMAIL,
  HASH_TOKEN,
  TOKEN_NOTIFICATION,
  USER,
  USERID,
} from "../config/constants";

export function getAccessTokenApi() {
  const accessToken = localStorage.getItem(HASH_TOKEN);

  if (!accessToken || accessToken === "null") {
    return null;
  }

  //   return willExpireToken(accessToken) ? null : accessToken;
  return accessToken;
}

export function signInApi(data) {
  const url = `${BACKEND_URL}/customers/authenticate`;
  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

export function requestAccessApi(data) {
  const url = `${BACKEND_URL}/customers/createHashToken`;
  const params = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetch(url, params)
    .then((response) => {
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      return err.message;
    });
}

const removeDeviceID = async (userID, tokenDevice) => {
  const url = `${BACKEND_URL}/customers/removeDeviceID`;

  try {
    const bodyObj = {
      contact: userID,
      deviceID: tokenDevice,
    };

    const { data } = await axios.post(url, bodyObj);

    return data;
  } catch (error) {
    console.log("error catch delete token device id", error);
  }
};

export async function logout() {
  try {
    const userID = localStorage.getItem(USERID);
    const tokenDevice = localStorage.getItem(TOKEN_NOTIFICATION);

    if (
      tokenDevice &&
      tokenDevice !== null &&
      tokenDevice !== undefined &&
      tokenDevice !== "undefined"
    ) {
      const resultRemove = await removeDeviceID(userID, tokenDevice);

      console.log("resultado de remover el token", resultRemove);
    }
    localStorage.removeItem(HASH_TOKEN);
    localStorage.removeItem(DISPLAYNAME);
    localStorage.removeItem(USER);
    localStorage.removeItem(EMAIL);
    localStorage.removeItem(HASH_TOKEN);
    localStorage.removeItem(ACCOUNTS);
    localStorage.removeItem(TOKEN_NOTIFICATION);
    return true;
  } catch (error) {
    console.log("error catch logout", error);
    return false;
  }

  // window.location.href = "/";
}
